(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sls-global"]) return;
  try {
    
  (function () {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    /* Bare på produktsider, også med språkprefiks (/da/products/...).
       Forsiden og kolleksjoner har kjøpsskjemaer i produktkortene
       og i fremhevede produkter, og de skal ikke få linjen. */
    if (!/\/products\//.test(window.location.pathname)) return;

    function init() {
      /* Hovedproduktets skjema: Dawn gir det id "product-form-template--...".
         Produktkort og "Passer godt sammen med" bruker "quick-add-...". */
      var form = document.querySelector('form[id^="product-form-template"][action*="/cart/add"]');
      if (!form) return;
      var mainBtn = form.querySelector('[name="add"]');
      if (!mainBtn) return;

      var info = form.closest('.product__info-container') || document;
      var titleEl = info.querySelector('.product__title h1') || document.querySelector('.product__title h1');
      var priceEl = info.querySelector('.price__container .price-item--last, .price__container .price-item--regular');

      var bar = document.createElement('div');
      bar.className = 'sls-sticky-atc';
      bar.innerHTML =
        '<div class="sls-sticky-atc__info">' +
        '<span class="sls-sticky-atc__title"></span>' +
        '<span class="sls-sticky-atc__price"></span>' +
        '</div>' +
        '<button type="button" class="sls-sticky-atc__button"></button>';
      document.body.appendChild(bar);
      document.body.classList.add('sls-has-sticky');

      var barTitle = bar.querySelector('.sls-sticky-atc__title');
      var barPrice = bar.querySelector('.sls-sticky-atc__price');
      var barBtn = bar.querySelector('.sls-sticky-atc__button');

      function sync() {
        if (titleEl) barTitle.textContent = titleEl.textContent.trim();
        var p = info.querySelector('.price--on-sale .price-item--sale') || priceEl;
        if (p) barPrice.textContent = p.textContent.trim();
        var label = mainBtn.querySelector('span');
        barBtn.textContent = label ? label.textContent.trim() : mainBtn.textContent.trim();
        barBtn.disabled = mainBtn.disabled;
      }
      sync();

      barBtn.addEventListener('click', function () {
        mainBtn.click();
      });

      new MutationObserver(sync).observe(info === document ? form : info, {
        subtree: true,
        childList: true,
        attributes: true
      });

      new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(mainBtn);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
